<template>
  <div class="contentHome">
    <div class="centerPage">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
        <el-breadcrumb-item>
          <a href="/admin/consultationManage" class="aHref">专家讨论</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>讨论详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="formUserInfo">
        <div class="newCon img" :style="'backgroundImage: url('+details.thumbnailPath+')'">
          <h1 class="overflow">{{ details.title }}</h1>
          <p class="overflow">{{ details.subTitle }}</p>
        </div>
        <div class="detailCon">
          <div class="indicationsTit">
            <span class="tit">探讨介绍</span>
            <p>{{ details.briefDesc }}</p>
          </div>
          <div class="indicationsTit">
            <span class="tit">参与专家</span>
            <div class="expert flex">
              <div class="swiperImg flex" style="cursor: pointer" v-for="(item,index) in details.doctors" :key="index"
                   @click="doctorDetails(item.id)">
                <!--                            <img :src="item.headImgPath" alt="" height="100%">-->
                <div :style="'backgroundImage: url('+item.headImgPath+')'" class="img"></div>
                <div class="ri">
                  <strong>{{ item.fullName }}</strong><br/>
                  <span>咨询专长：{{ item.indications | indicationFormatter }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="indicationsTit">
            <span class="tit">会诊时间</span>
            <p>{{ details | dateFormatter }}</p>
          </div>
          <div class="indicationsTit">
            <span class="tit">会诊地点</span>
            <p>{{ details.meetPlace }}</p>
          </div>
          <div class="indicationsTit">
            <span class="tit">讨论说明</span>
            <div v-html="details.explanation"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import base from '@/api/common';

export default {
  name: "consultationDetails",
  data() {
    return {
      id: this.$route.params.id,
      details: {
        doctors: []
      }
    }
  },
  mounted() {
    this.$ajax.get(base.manager_api.expert.consultation.details.replace("{id}", this.id)).then(res => {
      if (res.data.status === 'success') {
        this.details = res.data.data;
      }
    });
  },
  methods: {
    doctorDetails(id) {
      //alert("to doctor details....");
      //console.log("to doctor details: " + id);
    }
  },
  filters: {
    dateFormatter(item) {
      let startDate = item.meetStartDate;
      let endDate = item.meetEndDate;
      if (startDate && endDate) {
        let s = new Date(startDate.replace(/-/g, "/"));
        let e = new Date(endDate.replace(/-/g, "/"));
        return s.Format("yyyy年MM月dd日 HH:mm") + " - " + e.Format("yyyy年MM月dd日 HH:mm");
      }
      return "-"
    },
    indicationFormatter(indications) {
      if (indications && indications.length > 0) {
        let arr = [];
        $(indications).each((i, o) => {
          arr.push(o.cnName);
        })
        return arr.join("、");
      }
      return "";
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/medication.scss';

.centerPage {
  display: block;
  width: auto;
  padding: 0;

  .formUserInfo {
    margin-top: 20px;
  }
}
</style>